const central = [
    {
        name:'Add Zone Coordinator',
        link:'/add-coordinator'
    },
    {
        name:'Add Logistics User',
        link:'/add-logistics-user'
    },
    {
        name:'Add Item Inventory',
        link:'/add-item'
    },
    {
        name:'Upload Item Inventory',
        link:'/upload-item'
    },
    {
        name:'Upload Dish Inventory',
        link:'/upload-dish'
    },
    {
        name:'Add Supplier',
        link:'/add-supplier'
    },
    {
        name:'Create Menu',
        link:'central/create-menu'
    },
    {
        name:'Create Dish',
        link:'central/create-dish'
    },
    {
        name:'My Profile',
        link:'/profile'
    },
    {
        name:'Miqaats',
        link:'/zc/view-miqaats'
    },
    {
        name:'Logout',
        link:'/logout'
    }
]

const zc = [
    {
        name:'Add Zone Supplier',
        link:'zc/add-ZoneSupplier'
    },
    {
        name:'Miqaats',
        link:'/zc/view-miqaats'
    },
    {
        name:'My Profile',
        link:'/profile'
    },
    {
        name:'Logout',
        link:'/logout'
    }
]
const supplier = [
    {
        name:'Logout',
        link:'/logout'
    }
]
const silat = [
    {
        name:'Logout',
        link:'/logout'
    }
]

const logistics = [
    {
        name:'Purchase Orders',
        link:'/logistics/home'
    },
    {
        name:'My Profile',
        link:'/profile'
    },
    {
        name:'Logout',
        link:'/logout'
    }
]

const silatViewer = [
    {
        name:'Silat Commitments',
        link:'silat/commitments'
    },
    {
        name:'Silat Dashboard',
        link:'silat/silatdash'
    },
    {
        name:'My Profile',
        link:'/profile'
    },
    {
        name:'Logout',
        link:'/logout'
    }
]

export {
    central,zc,supplier,silat,logistics,silatViewer
}